(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/shared-components/tir-service.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/shared-components/tir-service.js'); "use strict";


const {
  jupiter
} = svs.core;
const {
  logger
} = svs.termsIntegrity;

const getCmsDataDocumentAsync = async id => {
  try {
    const options = {
      method: 'GET',
      path: new svs.content.shared.ContentUrlBuilder('id').addParams({
        ids: [id],
        count: 100
      }).build()
    };
    logger.debug('Call to getCmsDataDocumentAsync with options: ', options);
    const {
      response
    } = await jupiter.callAsync(options);
    logger.debug('Call to getCmsDataDocumentAsync response: ', response);
    return response;
  } catch (error) {
    logger.error('Error getting CMS Data Async', error);
    return {
      error
    };
  }
};

const getCmsDataFolderAsync = async parentId => {
  try {
    const options = {
      method: 'GET',
      path: new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({
        parentId,
        count: 100
      }).build()
    };
    logger.debug('Call to getCmsDataFolderAsync with options: ', options);
    const {
      response
    } = await jupiter.callAsync(options);
    logger.debug('Call to getCmsDataFolderAsync response: ', response);
    return response;
  } catch (error) {
    logger.error('Error getting CMS Data Async', error);
    return {
      error
    };
  }
};
svs.termsIntegrity.sharedComponents.TirService = {
  getCmsDataDocumentAsync,
  getCmsDataFolderAsync
};
 })(window);